import { Col, Row } from 'antd';
import { useField } from 'formik';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useListUsersQuery } from '../../../../../../api/queries/listUsers';
import SelectField from '../../../../../../components/fields/SelectField';
import SwitchField from '../../../../../../components/fields/SwitchField';
import useSystemSwitchData from '../../../../../../utilities/useSystemSwitchData';

type MobilityHomeDeliveryProps = {
    name: string;
    companiesIds: string[];
};
const MobilityHomeDelivery = ({ name, companiesIds }: MobilityHomeDeliveryProps) => {
    const { t } = useTranslation();
    const { yesNoSwitch } = useSystemSwitchData();

    const [field] = useField({ name });
    const { value } = field;

    const { data, loading } = useListUsersQuery({
        fetchPolicy: 'cache-and-network',
        variables: {
            filter: {
                companyIds: companiesIds,
            },
        },
    });

    const assigneeOptions = useMemo(
        () =>
            [
                { label: t('common:none'), value: null },
                ...(data?.list?.items || []).map(user => ({
                    label: user.displayName,
                    value: user.id,
                })),
            ].filter(Boolean),
        [data?.list?.items, t]
    );

    return (
        <Row>
            <Col md={8} xs={24}>
                <SwitchField
                    {...t('mobilityModuleDetails:fields.mobilityHomeDelivery.isEnable', { returnObjects: true })}
                    name={`${name}.isEnable`}
                    {...yesNoSwitch}
                    required
                />
            </Col>

            {value.isEnable && (
                <Col md={8} xs={24}>
                    <SelectField
                        {...t('mobilityModuleDetails:fields.mobilityHomeDelivery.assignee', { returnObjects: true })}
                        filterOption={(input, option) =>
                            (option?.label.toString() ?? '').toLowerCase().includes(input.toLowerCase())
                        }
                        loading={loading}
                        name={`${name}.assigneeId`}
                        options={assigneeOptions}
                        showSearch
                    />
                </Col>
            )}
        </Row>
    );
};

export default MobilityHomeDelivery;
